function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 6,
  width: 32,
  height: 32,
  rx: 16,
  fill: "#77BC1F"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35 21.5C35.0034 22.8199 34.6951 24.1219 34.1 25.3C33.3944 26.7118 32.3098 27.8992 30.9674 28.7293C29.6251 29.5594 28.0782 29.9994 26.5 30C25.1801 30.0035 23.8781 29.6951 22.7 29.1L17 31L18.9 25.3C18.3049 24.1219 17.9966 22.8199 18 21.5C18.0006 19.9218 18.4406 18.3749 19.2707 17.0326C20.1008 15.6903 21.2883 14.6056 22.7 13.9C23.8781 13.305 25.1801 12.9966 26.5 13H27C29.0843 13.115 31.053 13.9948 32.5291 15.4709C34.0052 16.947 34.885 18.9157 35 21V21.5Z",
  stroke: "#F8F7F2",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: 0,
  width: 52,
  height: 52,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgFaleComAGente = function SvgFaleComAGente(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 45,
    viewBox: "0 0 52 45",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaleComAGente, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fale-com-a-gente.33ceace6.svg";
export { ForwardRef as ReactComponent };